<template>
  <div class="content">
    <!-- <offline @detected-condition="handleConnectivityChange"></offline> -->
    <transition name="fade" mode="out-in">
      <!-- your content here -->
      <div>
        <div>
          <router-view></router-view>
        </div>
      </div>
    </transition>
  </div>
  
</template>
<script>
  import Vue from 'vue';
  import offline from 'v-offline';
  Vue.use(offline);
  export default {
    components: {
      offline
  },
  data() {
    return {
      offlineDisplay: false,
      routerViewDisplay: true,
      wifi_error_image: process.env.VUE_APP_BASE_ROUTE+'img/wifi_error.png',
    };
  },
  methods: {
    // Función que verifica si hay internet y muestra el mensaje permanente
    handleConnectivityChange(status) {
      if(status == false)
      {
          this.$store.dispatch('setConnectivityState', status);
          this.$notify(
            {
                message: 'No hay conexión a internet en este momento',
                icon: 'nc-icon nc-alert-circle-i',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
      }
      else
      {
          const url = process.env.VUE_APP_BACKEND_URL +'/api/gencookie';
          fetch(url)
          .then(data => data)
          .then(res => {
            // el resultado no importa, solo importa la cookie
            
          })
          .catch(error => { 
            console.info("Ocurrió un error al obtener la cookie!");
          });
          this.$store.dispatch('setConnectivityState', status);
          this.$notify(
            {
                message: 'La conexión a internet ha sido restablecida',
                icon: 'nc-icon nc-spaceship',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
            })
      }
    },
  },
  }
</script>
<style>
  .center {
    padding: 3em 1.5em;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
